import React from 'react';
import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(RelativeTime);
const MessageDate = (props) => {
  const { date, spacingTop, showDetailedDate } = props;
  const messageDate = dayjs(date);
  const now = dayjs();

  return (
    <div
      className={
        spacingTop ? 'message-date message-date--spacing-top' : 'message-date'
      }>
      {now.year() === messageDate.year()
        ? now.format('D MMM') === messageDate.format('D MMM')
          ? messageDate.fromNow()
          : messageDate.format(showDetailedDate ? 'D MMM [at] HH:mm' : 'D MMM')
        : dayjs(date).format(
            showDetailedDate ? 'D MMM YYYY [at] HH:mm' : 'D MMM YYYY',
          )}
    </div>
  );
};

export default MessageDate;
